import type { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

interface DroppableWrapperStyleProps {
  isDraggingOver: boolean;
  isDraggingFrom: boolean;
}

const getBackgroundColor = (
  theme: Theme,
  isDraggingOver: boolean,
  isDraggingFrom: boolean,
): string => {
  if (isDraggingOver) {
    return theme.palette.grey[100];
  }
  if (isDraggingFrom) {
    return theme.palette.grey[200];
  }
  return theme.palette.common.white;
};

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ({
      isDraggingOver,
      isDraggingFrom,
    }: DroppableWrapperStyleProps) =>
      getBackgroundColor(theme, isDraggingOver, isDraggingFrom),
  },
}));
